import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

const Wrap = ({ children }) => (
  <div className="min-h-screen bg-lc-navy text-white">
    <div className="mx-auto max-w-3xl px-6 py-20">
      <Link to="/" className="font-mono text-[11px] uppercase tracking-widest text-lc-sky hover:underline">← LC Shield</Link>
      {children}
      <div className="mt-10 flex flex-col gap-0.5 text-[11px] text-lc-steel">
        <span>
          A product of DZent Limited (Hong Kong) ·{" "}
          <a href="https://dzentlimited.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">dzentlimited.com</a>
        </span>
        <span>© 2026 DZent Limited (Hong Kong)</span>
        <span>LC Shield is an independent tool and is not affiliated with or endorsed by the ICC.</span>
      </div>
    </div>
  </div>
);

export function Contact() {
  return (
    <Wrap>
      <Seo title="Contact | LC Shield" description="Contact LC Shield support — operated by DZent Limited, Hong Kong." path="/contact" />
      <h1 className="mt-8 font-serif text-3xl sm:text-4xl" data-testid="contact-heading">Contact</h1>
      <p className="mt-4 text-sm leading-relaxed text-lc-fog">Questions about LC Shield or your audit? We're happy to help.</p>
      <ul className="mt-5 space-y-2 text-sm text-white">
        <li>Support: <a className="text-lc-sky hover:underline" href="mailto:support@getlcshield.com">support@getlcshield.com</a></li>
        <li>DZent Limited, Hong Kong</li>
      </ul>
    </Wrap>
  );
}

export function Security() {
  return (
    <Wrap>
      <Seo title="Security | LC Shield" description="How LC Shield handles your documents and payments." path="/security" />
      <h1 className="mt-8 font-serif text-3xl sm:text-4xl" data-testid="security-heading">Security</h1>
      <ul className="mt-5 space-y-3 text-sm leading-relaxed text-lc-fog">
        <li>• Documents are processed by our AI provider for analysis.</li>
        <li>• Uploaded documents are not retained after analysis.</li>
        <li>• Firm-plan audit history is stored only if you opt in.</li>
        <li>• Payments are processed by Stripe.</li>
      </ul>
    </Wrap>
  );
}

export function NotFound() {
  return (
    <Wrap>
      <Seo title="Page not found | LC Shield" description="The page you were looking for could not be found." robots="noindex, follow" />
      <h1 className="mt-8 font-serif text-4xl sm:text-5xl" data-testid="notfound-heading">Page not found</h1>
      <p className="mt-4 text-sm text-lc-fog">The page you were looking for doesn't exist or has moved.</p>
      <Link to="/" className="mt-6 inline-block rounded-md bg-lc-sky px-5 py-2.5 text-sm font-semibold text-lc-navy hover:opacity-90" data-testid="notfound-home-link">Go to homepage</Link>
    </Wrap>
  );
}
